import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
import {map} from 'rxjs/operators';

const userRoutes = {
    getCurrentUser: () => `im/apea/security/get-current-user`,
    getAllUsers: () => `im/apea/security/users`,
    getDetailedLoggedInUser: (userId: any) => `v1/users/${userId}`,
    getAdminRolesDropdown: () => `v1/parent-role-vos`,
    getStdCodes: () => `v1/country-std-codes`,
    whatsAppOptIn: () => `v1/opt-in-whatsapp-number`,
    whatsAppOptOut: () => `v1/opt-out-whatsapp-number`,
};

@Injectable({
    providedIn: 'root'
})
export class ImUserService {

    constructor(private httpClient: HttpClient) {
    }

    getLoggedInUser() {
        const $loggedInUser: Observable<any> = this.httpClient
            .get(userRoutes.getCurrentUser())
            .pipe(
                map(
                    (x) => {
                        return x as any;
                    }
                )
            );
        return $loggedInUser;
    }

    getAllUsers() {
        const $allUsers: Observable<any> = this.httpClient
            .get(userRoutes.getAllUsers())
            .pipe(
                map(
                    (x) => {
                        return x as any;
                    }
                )
            );
        return $allUsers;
    }

    getDetailedLoginUser(userId: any) {
        const $userDetail: Observable<any> = this.httpClient
            .get(userRoutes.getDetailedLoggedInUser(userId))
            .pipe(
                map(
                    (x) => {
                        return x as any;
                    }
                )
            );
        return $userDetail;
    }

    getAdminRolesDropdown() {
        const $adminRoles: Observable<any> = this.httpClient
            .get(userRoutes.getAdminRolesDropdown())
            .pipe(
                map(
                    (x) => {
                        return x as any;
                    }
                )
            );
        return $adminRoles;
    }

    getStdCodes() {
        const $stdCodes: Observable<any> = this.httpClient
            .get(userRoutes.getStdCodes())
            .pipe(
                map(
                    (x) => {
                        return x as any;
                    }
                )
            );
        return $stdCodes;
    }

    getWhatsappOptIn(stdcode: any, phonenumber: any) {
        const $opt: Observable<any> = this.httpClient
            .get(userRoutes.whatsAppOptIn(), {
                params: {
                    stdcode,
                    phonenumber
                }
            }).pipe(
                map((x) => {
                    return x as any;
                })
            );
        return $opt;
    }

    getWhatsappOptOut(stdcode: any, phonenumber: any) {
        const $opt: Observable<any> = this.httpClient
            .get(userRoutes.whatsAppOptOut(), {
                params: {
                    stdcode,
                    phonenumber
                }
            }).pipe(
                map((x) => {
                    return x as any;
                })
            );
        return $opt;
    }

}
